/**
 * `router/contact.js`
 *  - お問い合わせページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {contactRouter} from "./router/contact.js";
 */


import {initMwWpForm} from "../core/wordpress/mwwpform/mwwpform.js";
import {initForm} from "../modules/form.js";


export const contactRouter = (data) => {
  console.log("📖 Initializing contact page...");

  initMwWpForm(data);
  initForm();
}